import React from 'react'

export const ContactConfig = {
    settings: {
        layout: {
            config: {
                navbar: {
                    display: false
                },
                toolbar: {
                    display: false
                },
                footer: {
                    display: false
                },
                leftSidePanel: {
                    display: false
                },
                rightSidePanel: {
                    display: false
                }
            }
        }
    },
    routes: [
        {
            path: '/contact',
            component: React.lazy(() => import('./Contact')),
            applicationPath: ['Contact']
        }
    ]
}

